import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { IMAGES } from "../data/site";
import FlowerDivider from "../components/FlowerDivider";

export default function SechsTibeter() {
  const { t } = useLang();
  useEffect(() => window.scrollTo({ top: 0 }), []);
  return (
    <main className="pt-28 md:pt-32" data-testid="tibeter-page">
      <section className="py-14 md:py-20">
        <div className="container-x text-center">
          <p className="uppercase tracking-[0.3em] text-xs text-[var(--gold)]">{t.tibeter.label}</p>
          <h1 className="display text-4xl sm:text-5xl md:text-7xl mt-3">{t.tibeter.title}</h1>
          <FlowerDivider />
          <p className="font-serif italic text-lg md:text-2xl text-[var(--gold-dark)] max-w-2xl mx-auto">{t.tibeter.sub}</p>
        </div>

        <div className="container-x grid md:grid-cols-12 gap-8 md:gap-10 mt-10 md:mt-14 items-start">
          <div className="md:col-span-5">
            <div className="img-mask aspect-[4/5] rounded-3xl"><img src={IMAGES.offerTibeter} alt={t.tibeter.title} /></div>
          </div>
          <div className="md:col-span-7 space-y-4 md:space-y-5 text-[16px] md:text-[17px] leading-relaxed text-[var(--ink-soft)]">
            <p>{t.tibeter.p1}</p>
            <p>{t.tibeter.p2}</p>
            <div className="bg-[var(--gold)]/10 rounded-3xl p-6 md:p-7 border border-[var(--gold)]/25 mt-5">
              <div className="font-serif text-xl md:text-2xl mb-4">{t.tibeter.effectsTitle}</div>
              <ul className="space-y-2.5 md:space-y-3">
                {t.tibeter.effects.map((e, i) => (
                  <li key={i} className="flex items-start gap-3 text-[15px] md:text-[16px]">
                    <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[var(--gold)] shrink-0" /><span>{e}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="container-x text-center mt-10 md:mt-14">
          <Link to="/kontakt" className="inline-flex items-center gap-2 px-9 py-4 rounded-full bg-[var(--gold)] text-[var(--ink)] font-medium hover:bg-[var(--gold-dark)] hover:text-white transition-all">
            {t.hero.cta} <ArrowRight size={16} />
          </Link>
        </div>
      </section>
    </main>
  );
}
